// https://developer.vimeo.com/player/sdk/reference を参照
export const VIMEO_EVENT_PLAY = 'play';
export const VIMEO_EVENT_TIMEUPDATE = 'timeupdate';
export const VIMEO_EVENT_ENDED = 'ended';
// live配信中のsecondsについて
// PCではライブ開始時間からの経過秒数を返却する
// SP/Padではiframeレンダリングからの経過秒数を返却する
